import { defineComponent as q, onMounted as R, onBeforeUnmount as v, createElementBlock as i, openBlock as u, createElementVNode as s, createCommentVNode as c, normalizeClass as y, unref as t, createVNode as m, createTextVNode as p, toDisplayString as h, nextTick as S } from "vue";
import { ScalarHotkey as d } from "@scalar/components";
import { useRoute as C, useRouter as N } from "vue-router";
import B from "../../../assets/computer.ascii.js";
import V from "../../../components/EmptyState.vue.js";
import E from "../../../components/ScalarAsciiArt.vue.js";
import { useWorkspace as K } from "../../../store/store.js";
import { useLayout as A } from "../../../hooks/useLayout.js";
const W = { class: "flex-center relative flex flex-1 flex-col gap-6 p-2 capitalize" }, $ = {
  key: 0,
  class: "scalar-version-number"
}, j = { class: "text-c-3 right-4 mt-auto flex w-full flex-col items-end gap-2 text-sm" }, U = /* @__PURE__ */ q({
  __name: "ResponseEmpty",
  props: {
    collection: {},
    operation: {},
    workspace: {},
    numWorkspaceRequests: {}
  },
  setup(r) {
    const { events: a, requestMutators: x } = K(), g = C(), b = N(), { layout: n } = A(), f = () => {
      var l;
      const o = (l = r.operation.tags) != null && l.length ? { tags: r.operation.tags[0] ? [r.operation.tags[0]] : [] } : {}, e = x.add(o, r.collection.uid);
      e && (b.push({
        name: "request",
        params: {
          workspace: r.workspace.uid,
          request: e.uid
        }
      }), S(() => {
        a.hotKeys.emit({
          focusAddressBar: new KeyboardEvent("keydown", { key: "l" })
        });
      }));
    }, k = (o) => {
      o != null && o.createNew && g.name === "request" && f();
    }, w = "2.5.29";
    return R(() => a.hotKeys.on(k)), v(() => a.hotKeys.off(k)), (o, e) => (u(), i("div", W, [
      s("div", {
        class: y(["flex h-[calc(100%_-_50px)] flex-col items-center justify-center", {
          "hidden opacity-0": o.numWorkspaceRequests <= 1 && t(n) !== "modal"
        }])
      }, [
        t(n) !== "modal" ? (u(), i("div", $, [
          p(" Scalar App V" + h(t(w)) + " Beta ", 1),
          e[3] || (e[3] = s("div", { class: "mt-2" }, [
            s("a", {
              href: "https://github.com/scalar/scalar/issues/2669",
              target: "_blank"
            }, " Roadmap ")
          ], -1))
        ])) : c("", !0),
        e[4] || (e[4] = s("a", {
          class: "gitbook-show scalar-version-number",
          href: "https://www.scalar.com",
          target: "_blank"
        }, " Powered By Scalar.com ", -1)),
        m(E, {
          art: t(B),
          class: "text-c-3"
        }, null, 8, ["art"])
      ], 2),
      t(n) !== "modal" ? (u(), i("div", {
        key: 0,
        class: y(["hidden h-[calc(100%_-_50px)] items-center justify-center pb-5", {
          "!flex opacity-100": o.numWorkspaceRequests == 1
        }])
      }, [
        m(V)
      ], 2)) : c("", !0),
      s("div", j, [
        t(n) !== "modal" ? (u(), i("button", {
          key: 0,
          class: "flex items-center gap-1.5",
          type: "button",
          onClick: e[0] || (e[0] = (l) => t(a).commandPalette.emit())
        }, [
          e[5] || (e[5] = p(" Get Started ")),
          m(t(d), { hotkey: "k" })
        ])) : c("", !0),
        t(n) === "desktop" ? (u(), i("button", {
          key: 1,
          class: "flex items-center gap-1.5",
          type: "button",
          onClick: e[1] || (e[1] = (l) => f())
        }, [
          e[6] || (e[6] = p(" New Request ")),
          m(t(d), { hotkey: "N" })
        ])) : c("", !0),
        s("button", {
          class: "flex items-center gap-1.5",
          type: "button",
          onClick: e[2] || (e[2] = (l) => t(a).executeRequest.emit())
        }, [
          e[7] || (e[7] = p(" Send Request ")),
          m(t(d), { hotkey: "↵" })
        ])
      ])
    ]));
  }
});
export {
  U as default
};
